// Public "from" price wording, GBP first with an approximate USD (owner decision
// 2026-10-22: "from £28 (about $37)"). Display only: checkout prices bookings on
// the server from the database and never reads this file.
//
// ABOUT_USD_PER_GBP is a deliberately rounded display rate, used with ordinary
// rounding: £28 → $37.24 → "about $37", £31.99 → $42.55 → "about $43". (The
// checkout showed £28 → $37.52, i.e. 1.34, on 2026-09-08; 1.33 is within normal
// GBP/USD drift and gives the decided wording without special-case rounding.)
// Review periodically; it is one line.
export const ABOUT_USD_PER_GBP = 1.33;

function formatGbpAmount(gbp) {
  const n = Number(gbp);
  if (Number.isInteger(n)) {
    return `£${n}`;
  }
  return `£${n.toFixed(2)}`;
}

export function formatFareShort(gbp) {
  return formatGbpAmount(gbp);
}

export function approximateUsd(gbp) {
  return Math.round(Number(gbp) * ABOUT_USD_PER_GBP);
}

/** "£28 (about $37)" — for places that supply their own "from"/"Fares from" label. */
export function formatFare(gbp) {
  return `${formatGbpAmount(gbp)} (about $${approximateUsd(gbp)})`;
}

/** "from £28 (about $37)" */
export function formatFromPrice(gbp) {
  return `from ${formatFare(gbp)}`;
}
